<template>
  <div class="my-wrap finance-wrap">
    <div v-if="selectedPayment" class="deposit-frame">
      <div class="my-deposit-frame">
        <div class="my-deposit my-d-box">
          <!-- ══════════════ Mobile 版 ══════════════ -->
          <div class="my-deposit-package-mobile">
            <div class="mobile-frame">
              <!-- Mobile Tab -->
              <div class="mobile-frame">
                <DepositTabNav
                  :is-buy-crypto.sync="isBuyCrypto"
                />
              </div>

              <div class="mobile-frame ewallet-group">
                <div class="ewallet-shared">
                  <!-- 活動優惠碼 -->
                  <promo-code ref="promoCodeMb" @open-coupon="showCoupon = true" />
                  <div v-if="showCoupon" id="popup-coupon-manager" class="popup-frame" :class="{ active: showCoupon }">
                    <deposit-coupon-modal
                      v-if="showCoupon"
                      @applyCoupon="onApplyCoupon"
                      @closeCoupon="showCoupon = false"
                    />
                  </div>

                  <!-- Mobile 渠道下拉 -->
                  <div class="gold-top-frame">
                    <DepositChannelDropdown
                      :selected-payment="selectedPayment"
                      :filtered-payment-types="filteredPaymentTypes"
                      :is-buy-crypto="isBuyCrypto"
                      :is-open.sync="isMbDropdownOpen"
                      @select="onSelectPayment"
                    />
                  </div>
                </div>

                <div class="ewallet-channel-content">
                  <div class="gold-channel-frame">
                    <!-- 加密貨幣 -->
                    <crypto-detail
                      v-if="selectedPayment.typeNum === 3"
                      :selected-payment="selectedPayment"
                    />

                    <DepositUseJetonCash
                      v-if="selectedPayment.typeCode === 'JetonCash'"
                      :crypto-amount.sync="cryptoAmount"
                      :type-code="selectedPayment.typeCode"
                      :payment-name="selectedPayment.name"
                      :payment-id="selectedPayment.payment_id"
                      :jcash.sync="Jcash"
                      :currency-rate="currencyRate"
                      :time-left="timeLeft"
                      :formatted-time="formattedTime"
                      :jeton-voucher-errors="jetonVoucherErrors"
                      :jcash-expiration-date-errors="JcashExpirationDateErrors"
                      :jcash-security-code-errors="JcashSecurityCodeErrors"
                      :is-mobile="true"
                      uid="mb"
                      @crypto-input="validateNumber"
                      @recheck="handleRecheck"
                      @check-jeton-voucher="checkJetonVoucherErrors"
                      @format-jcash-exp="formatJcashExpirationDate"
                      @format-jcash-cvv="formatJcashSecurityCode"
                    />

                    <!-- 金額輸入 -->
                    <DepositAmountInput
                      v-if="selectedPayment.typeCode !== 'JetonCash'"
                      :amount="postForm.amount"
                      :selected-amount="selectedAmount"
                      :percent="percent"
                      :type-num="selectedPayment.typeNum"
                      :type-code="selectedPayment.typeCode"
                      :payment-code="selectedPayment.code"
                      :price-list="selectedPayment.price_list || []"
                      :is-buy-crypto="isBuyCrypto"
                      :show-label="false"
                      :show-range-bar="!isBuyCrypto"
                      :amount-min="selectedPayment.amount_limit_front.min"
                      :amount-max="selectedPayment.amount_limit_front.max"
                      @input="validateNumber"
                      @select-amount="handleAmount"
                    />

                    <DepositUseJetonPay
                      v-if="selectedPayment.typeCode === 'JetonPay'"
                      :type-code="selectedPayment.typeCode"
                      :jcash.sync="Jcash"
                      :jeton-errors="jetonErrors"
                      :is-mobile="true"
                      @check-jeton-errors="checkJetonErrors"
                    />

                    <DepositUseVega
                      v-if="selectedPayment.typeCode === 'VegaWallet'"
                      :other.sync="other"
                      :account-errors="accountErrors"
                      :is-mobile="true"
                      uid="mb"
                      @check-account-errors="checkAccountErrors"
                    />

                    <!-- 活動 Swiper（Mobile） -->
                    <DepositEventSwiper
                      v-if="isBuyCrypto"
                      ref="eventSwiperMb"
                      :sorted-events="sortedEvents"
                      :selected-event-id="selectedEvent && selectedEvent.id"
                      :member-type="memberInfo.member_type"
                      :is-mobile="true"
                      @select-event="handleEvent"
                    />

                    <!-- 摘要 + 存款按鈕 -->
                    <DepositSummary
                      v-if="selectedPayment.typeNum !== 3"
                      :payment-code="selectedPayment.code"
                      :payment-name="selectedPayment.name"
                      :amount="postForm.amount"
                      :event-bonus="eventBonus"
                      :total-bonus="calculateTotalBonus()"
                      :selected-event-type="selectedEvent && selectedEvent.type"
                      :deposit-count="count"
                      :currency="currency"
                      :is-buy-crypto="isBuyCrypto"
                    />
                  </div>
                  <DepositSendBtn
                    v-if="selectedPayment.typeNum !== 3"
                    :type-code="selectedPayment.typeCode"
                    :amount="postForm.amount"
                    :is-buy-crypto="isBuyCrypto"
                    :is-button-disable="isButtonDisable"
                    :show-deposit-guide="themeConfig.showDepositGuide"
                    @submit="checkIsDeposit"
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- Mobile end -->

          <!-- ══════════════ PC 版 ══════════════ -->
          <div class="my-deposit-package-n">
            <div class="pc-deposit-layout">
              <!-- PC 側邊渠道列表 -->
              <DepositChannelSidebar
                :filtered-payment-types="filteredPaymentTypes"
                :selected-payment="selectedPayment"
                @select="onSelectPayment"
              />

              <div class="pc-form-area">
                <div
                  class="slider-form form-frame"
                  :class="{ 'crypto-option crypto-secondary-channel': selectedPayment.typeNum === 3 }"
                >
                  <!-- 活動優惠碼 -->
                  <promo-code ref="promoCode" @open-coupon="showCoupon = true" />
                  <div v-if="showCoupon" id="popup-coupon-manager-pc" class="popup-frame" :class="{ active: showCoupon }">
                    <deposit-coupon-modal
                      v-if="showCoupon"
                      @applyCoupon="onApplyCoupon"
                      @closeCoupon="showCoupon = false"
                    />
                  </div>

                  <!-- 加密貨幣 -->
                  <crypto-detail
                    v-if="selectedPayment.typeNum === 3"
                    :selected-payment="selectedPayment"
                    class="row-frame"
                  />
                  <div class="ch-crypto-form D-none" />

                  <DepositUseJetonCash
                    v-if="selectedPayment.typeCode === 'JetonCash'"
                    :crypto-amount.sync="cryptoAmount"
                    :type-code="selectedPayment.typeCode"
                    :payment-name="selectedPayment.name"
                    :payment-id="selectedPayment.payment_id"
                    :jcash.sync="Jcash"
                    :currency-rate="currencyRate"
                    :time-left="timeLeft"
                    :formatted-time="formattedTime"
                    :jeton-voucher-errors="jetonVoucherErrors"
                    :jcash-expiration-date-errors="JcashExpirationDateErrors"
                    :jcash-security-code-errors="JcashSecurityCodeErrors"
                    uid="pc"
                    @recheck="handleRecheck"
                    @crypto-input="validateNumber"
                    @check-jeton-voucher="checkJetonVoucherErrors"
                    @format-jcash-exp="formatJcashExpirationDate"
                    @format-jcash-cvv="formatJcashSecurityCode"
                  />

                  <!-- 金額輸入 -->
                  <DepositAmountInput
                    v-if="selectedPayment.typeCode !== 'JetonCash'"
                    :amount="inputAmount"
                    :selected-amount="selectedAmount"
                    :percent="percent"
                    :type-num="selectedPayment.typeNum"
                    :type-code="selectedPayment.typeCode"
                    :payment-code="selectedPayment.code"
                    :price-list="selectedPayment.price_list || []"
                    :is-buy-crypto="isBuyCrypto"
                    :show-label="true"
                    :show-range-bar="false"
                    :amount-min="selectedPayment.amount_limit_front.min"
                    :amount-max="selectedPayment.amount_limit_front.max"
                    @input="validateNumber"
                    @select-amount="handleAmount"
                  />

                  <DepositUseJetonPay
                    v-if="selectedPayment.typeCode === 'JetonPay'"
                    :type-code="selectedPayment.typeCode"
                    :jcash.sync="Jcash"
                    :jeton-errors="jetonErrors"
                    @check-jeton-errors="checkJetonErrors"
                  />

                  <DepositUseVega
                    v-if="selectedPayment.typeCode === 'VegaWallet'"
                    :other.sync="other"
                    :account-errors="accountErrors"
                    uid="pc"
                    @check-account-errors="checkAccountErrors"
                  />

                  <!-- 活動 Swiper（PC） -->
                  <DepositEventSwiper
                    v-if="memberInfo.member_type !== 3 && sortedEvents"
                    v-once
                    ref="eventSwiperPc"
                    :sorted-events="sortedEvents"
                    :selected-event-id="selectedEvent && selectedEvent.id"
                    :member-type="memberInfo.member_type"
                    :is-mobile="false"
                    @select-event="handleEvent"
                  />

                  <!-- 摘要 + 存款按鈕 -->
                  <DepositSummary
                    v-if="selectedPayment.typeNum !== 3"
                    :payment-code="selectedPayment.code"
                    :payment-name="selectedPayment.name"
                    :amount="postForm.amount"
                    :event-bonus="eventBonus"
                    :total-bonus="calculateTotalBonus()"
                    :selected-event-type="selectedEvent && selectedEvent.type"
                    :deposit-count="count"
                    :currency="currency"
                    :is-buy-crypto="isBuyCrypto"
                  />
                </div>

                <DepositSendBtn
                  v-if="selectedPayment.typeNum !== 3"
                  :type-code="selectedPayment.typeCode"
                  :amount="postForm.amount"
                  :is-buy-crypto="isBuyCrypto"
                  :is-button-disable="isButtonDisable"
                  :show-deposit-guide="themeConfig.showDepositGuide"
                  @submit="checkIsDeposit"
                />
              </div>
            </div>
          </div>
          <!-- PC end -->
        </div>

        <!-- 首存提示 Modal -->
        <div v-if="showModel" class="popup-wrap" :class="{ active: showModel }">
          <div class="popup-box mx-395">
            <a class="popup-close" @click="showModel = false"><i class="fa-solid fa-xmark" /></a>
            <div class="form-popup popup-padding">
              <div class="popup-envelop">
                <div class="content">
                  <p>{{ $t('Bao.is_handle_deposit') }}</p>
                </div>
                <div class="form-button form-ft">
                  <button class="btn-primary" @click="handleSubmit">
                    <span>{{ $t('Bao.submit') }}</span>
                  </button>
                  <button class="btn-primary" @click="showModel = false">
                    <span>{{ $t('Bao.cancel') }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 安全碼提示 Modal -->
        <div v-if="showCVV" class="popup-frame popup-card-cvv" :class="{ active: showCVV }">
          <cardCVV v-if="showCVV" @closeCVV="showCVV = false" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendFirstPurchaseEvent } from '@/utils/pixel'
import { showNotice, setErrorMessage, detectMob } from '@/utils/tool'
import cardCVV from '@/components/modal/cardCVV'
import cryptoDetail from '@/components/deposit/cryptoDetail'
import promoCode from '@/components/deposit/promoCode.vue'
import depositCouponModal from '@/components/modal/depositCouponModal'
import {
  DepositType, DepositPayment, DepositSetting, DepositTransactions, checkDepositRate
} from '@/api/payment'
import { getMyCreditCards, getMyBanks } from '@/api/bank'
import { page } from '@/api/common'
import { getEvent, getEventDetail, joinEvent, getEventQualification } from '@/api/event'
import crypto from 'crypto-js'
import { mapGetters } from 'vuex'
import themeMixin from '@/mixins/themeMixin'
import paymentMixin from '@/mixins/paymentMixin'

import DepositTabNav from './DepositTabNav.vue'
import DepositChannelDropdown from './DepositChannelDropdown.vue'
import DepositChannelSidebar from './DepositChannelSidebar.vue'
import DepositAmountInput from './DepositAmountInput.vue'
import DepositUseJetonCash from './DepositUseJetonCash.vue'
import DepositUseJetonPay from './DepositUseJetonPay.vue'
import DepositUseVega from './DepositUseVega.vue'
import DepositEventSwiper from './DepositEventSwiper.vue'
import DepositSummary from './DepositSummary.vue'
import DepositSendBtn from './DepositSendBtn.vue'

export default {
  components: {
    cardCVV, cryptoDetail, promoCode, depositCouponModal,
    DepositTabNav, DepositChannelDropdown, DepositChannelSidebar,
    DepositAmountInput, DepositUseJetonCash, DepositUseJetonPay, DepositUseVega, DepositEventSwiper, DepositSummary, DepositSendBtn
  },
  mixins: [themeMixin, paymentMixin],

  data() {
    return {
      other: [],
      cryptoAmount: '',
      selectedType: null,
      outerTypes: [],
      types: [],
      selectedPayment: null,
      postForm: {
        payment_id: null,
        amount: 0,
        userName: '',
        join_event_info: [],
        event_type: null,
        default: null,
        currency: 'JPY'
      },
      events: [],
      eventBonus: 0,
      selectedEvent: null,
      deposit_v2: null,
      selectedAmount: null,
      selectedCrypto: {},
      selectedTypeName: '',
      selectedTypeCode: '',
      showCVV: false,
      showCoupon: false,
      percent: 0,
      typeDescriptions: {},
      count: 0,
      multipleDeposit: [],
      bounsLowerLimit: 0,
      todayArr: [],
      checkQual: true,
      lastResponseMessage: '',
      timer: null,
      timeLeft: 0,
      accountErrors: [],
      jetonErrors: [],
      jetonVoucherErrors: [],
      JcashExpirationDateErrors: [],
      JcashSecurityCodeErrors: [],
      creditCardNameErrors: [],
      creditCardNumErrors: [],
      creditCardExpirationDateErrors: [],
      creditCardSecurityCodeErrors: [],
      selectedCreditCard: null,
      depositEventRule: '',
      depositConfirmMessage: '',
      Jcash: {
        voucherNumber: '',
        expirationDate: '',
        securityCode: '',
        currency: 'EUR'
      },
      creditCard: {
        card_printed_name: '',
        credit_card_number: '',
        expirationDate: '',
        securityCode: ''
      },
      showModel: false,
      isHasCredit: false,
      isBuyCrypto: false,
      isMbDropdownOpen: false
    }
  },

  computed: {
    ...mapGetters(['user', 'memberInfo', 'brand', 'brandInfo', 'permissionInfo', 'app']),

    filteredPaymentTypes() {
      return this.outerTypes
        .filter(type => type.paymentMethods.length > 0)
        .sort((a, b) => {
          const order = { 2: 0, 1: 1, 3: 2, 4: 3 }
          return order[a.type] - order[b.type]
        })
    },
    currencyRate() {
      let isCheck
      if (this.selectedPayment &&
        (this.selectedPayment.typeCode === 'JetonCash' || this.selectedPayment.typeNum === 3)) {
        isCheck = this.types.find(type => type.typeName === this.selectedCrypto.typeName)
      }
      if (isCheck) {
        const exchangeRate = this.selectedPayment.typeNum === 3
          ? this.cryptoAmount / isCheck.deposit_rate
          : this.cryptoAmount * isCheck.deposit_rate

        const rate = exchangeRate % 1 !== 0 ? Number(exchangeRate).toFixed(4) : exchangeRate
        return {
          currencyRate: rate,
          deposit_rate: isCheck.deposit_rate,
          deposit_divide: 1 / isCheck.deposit_rate,
          payment_id: isCheck.payment_id,
          fetchName: isCheck.typeName
        }
      }
      return { currencyRate: 0, deposit_rate: 0, payment_id: 0 }
    },
    filteredTypes() {
      if (this.selectedPayment) {
        return this.types.filter(t => t.typeNum === 3 && t.name === this.selectedPayment.name)
      }
      return []
    },
    formattedTime() {
      const minutes = Math.floor(this.timeLeft / 60)
      const seconds = this.timeLeft % 60
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    },
    isButtonDisable() {
      const num = parseInt(this.postForm.amount, 10)
      const isInvalidAmount = isNaN(num) || num <= 0
      const cryptoNum = parseFloat(this.cryptoAmount)
      const isInvalidCryptoAmount = isNaN(cryptoNum) || cryptoNum <= 0
      const isDailyMultipleDeposit = this.selectedEvent?.type === 'daily_multiple_deposit' &&
        this.selectedPayment && num < this.bounsLowerLimit

      if (this.selectedCrypto && this.selectedCrypto.typeCode !== 'JetonCash') {
        return this.postForm.payment_id === null || isInvalidCryptoAmount || !this.timeLeft ||
          (isDailyMultipleDeposit && this.cryptoAmount < this.bounsLowerLimit)
      }
      if (this.selectedPayment?.name === 'VegaWallet') {
        return this.postForm.payment_id === null || isInvalidAmount || isDailyMultipleDeposit ||
          !this.other.password || this.accountErrors.length > 0
      }
      if (this.selectedPayment?.name === 'JetonPay') {
        return this.postForm.payment_id === null || isInvalidAmount || isDailyMultipleDeposit ||
          !this.other.uid || this.jetonErrors.length > 0
      }
      if (this.selectedPayment?.typeCode === 'JetonCash') {
        return this.postForm.payment_id === null || isDailyMultipleDeposit ||
          this.jetonVoucherErrors.length > 0 || this.JcashExpirationDateErrors.length > 0 ||
          this.JcashSecurityCodeErrors.length > 0 ||
          !this.Jcash.voucherNumber || !this.Jcash.expirationDate ||
          !this.Jcash.securityCode || !this.Jcash.currency || isInvalidAmount
      }
      if (this.selectedPayment?.typeCode === 'CreditCard' && this.selectedPayment?.code !== 'HeroPay') {
        return this.postForm.payment_id === null || isDailyMultipleDeposit ||
          !this.creditCard.credit_card_number.length || !this.creditCard.expirationDate ||
          !this.creditCard.securityCode || isInvalidAmount || !this.creditCard.card_printed_name
      }
      return this.postForm.payment_id === null || isInvalidAmount || isDailyMultipleDeposit
    },
    sortedEvents() {
      const events = [...this.user.sortedEvents]
      const allUnopened = events.every(e => this.isUnopenedEvent(e))
      if (allUnopened) return null
      return events.sort((a, b) => {
        if (this.isUnopenedEvent(a) && !this.isUnopenedEvent(b)) return 1
        if (!this.isUnopenedEvent(a) && this.isUnopenedEvent(b)) return -1
        return 0
      })
    },
    activityCount() {
      if (this.multipleDeposit?.setting) {
        return this.multipleDeposit.setting.reduce((count, week) => {
          return week.condition_value === this.getDayNumber() ? count + 1 : count
        }, 0)
      }
      return 0
    },
    first_deposit_at() { return this.memberInfo.first_deposit_at },
    currency() { return this.brand.currency },
    before_withdrawal_module_setting() { return this.brandInfo.before_withdrawal_module_setting },
    inputAmount() {
      return this.selectedPayment?.typeNum === 3 ? this.cryptoAmount : this.postForm.amount
    },
    AmoPay() {
      return this.selectedPayment?.code === 'AmoPay'
    }
  },

  watch: {
    selectedEvent() { this.calculateBonus() },
    selectedCreditCard() {
      const month = this.selectedCreditCard.expire_month
      const year = this.selectedCreditCard.expire_year
      this.creditCard.expirationDate = this.formatCardExpirationDateWhenSelect(month, year)
      this.creditCard.card_printed_name = this.selectedCreditCard.card_printed_name
    },
    'postForm.amount'() { this.calculateBonus() },
    cryptoAmount() { this.calculateBonus() },
    selectedCrypto(newValue) { if (newValue) this.resetTimer() },
    filteredTypes(newVal) { if (newVal.length > 0) this.selectedCrypto = newVal[0] },
    isBuyCrypto(val) {
      if (!this.isMobile()) {
        this.isBuyCrypto = false
        this.$router.push({ path: '/deposit', query: {}})
        this.postForm.amount = this.postForm.default
        this.cryptoAmount = ''
        this.selectedAmount = null
        this.selectedEvent = null
        this.eventBonus = 0
        this.percent = 0
        this.other = []
        return
      }

      if (val) {
        this.selectedEvent = null
        this.eventBonus = 0
      }
      this.$router.replace({
        query: { ...this.$route.query, mode: val ? 'buy' : undefined }
      }).catch(() => {})

      const firstTypeGroup = val
        ? this.outerTypes.find(t => t.type === 4 && t.paymentMethods.length > 0)
        : this.outerTypes.find(t => t.paymentMethods.length > 0)

      if (firstTypeGroup) {
        const p = firstTypeGroup.paymentMethods[0]
        this.onSelectPayment(p)
      }
    }
  },

  created() {
    Promise.all([DepositType(), DepositSetting()])
      .then(([typeResponse, settingResponse]) => {
        this.postForm.default = parseInt(
          parseFloat(settingResponse.data.data.info.default_deposit_amount)
        )

        const flattenedPayments = typeResponse.data.data.reduce((acc, type) => {
          const mapped = type.payments.map(payment => ({
            ...payment,
            typeName: type.name,
            typeCode: type.code,
            typeNum: type.type,
            typeImage: type.image,
            typeHey: type.hey
          }))
          return acc.concat(mapped)
        }, [])

        const groupedPayments = flattenedPayments.reduce((acc, payment) => {
          const existing = acc.find(item => item.type === payment.typeNum)
          if (existing) {
            if (!existing.paymentMethods.find(pm => pm.name === payment.name)) {
              existing.paymentMethods.push(payment)
            }
          } else {
            acc.push({ type: payment.typeNum, paymentMethods: [payment] })
          }
          return acc
        }, [])

        this.outerTypes = [
          { type: 2, paymentMethods: [] },
          { type: 1, paymentMethods: [] },
          { type: 3, paymentMethods: [] },
          { type: 4, paymentMethods: [] }
        ].map(predef => groupedPayments.find(g => g.type === predef.type) || predef)

        this.outerTypes.forEach(type => {
          type.paymentMethods = type.paymentMethods.filter(payment =>
            payment.allow_member_level.includes(String(this.memberInfo.vl)) &&
            payment.typeHey === this.memberInfo.vip_level_id
          )
        })
        this.types = flattenedPayments

        if (this.$route.query.mode === 'buy') this.isBuyCrypto = true

        const firstTypeGroup = this.outerTypes.find(t => t.paymentMethods.length > 0)
        if (firstTypeGroup) {
          const p = firstTypeGroup.paymentMethods[0]
          this.onSelectPayment(p)
        }

        const selectedWallet = this.app.selectedWallet
        if (selectedWallet &&
          !['main', 'commission', 'bonus'].includes(selectedWallet.wallet_type)) {
          const ccPayment = this.filteredPaymentTypes.flatMap(t => t.paymentMethods)
            .find(m => m.name === 'CcPayment')
          if (ccPayment) {
            this.onSelectPayment(ccPayment)
            if (this.isMobile()) {
              this.$nextTick(() => {
                this.selectedType = 3
              })
            }
          }
        }
      })
      .catch((error) => {
        const result = error?.response?.data
        if (result?.status === 403) {
          showNotice(result.msg, () => { this.$router.push('/') })
        }
      })

    getMyCreditCards().then(r => { this.creditCard.credit_card_number = r.data.data })
    getMyBanks().then(r => {
      this.isHasCredit = r.data.data.some(i => i.bank_type === 1)
    })

    page({ type: 'deposit_event_rule' }).then(r => { this.depositEventRule = r.data.data.content })
    page({ type: 'deposit_confirm_message' }).then(r => { this.depositConfirmMessage = r.data.data.content })

    getEvent().then((response) => {
      for (const item of response.data.data.list) {
        if (item.is_show_in_deposit !== 0) {
          if (item.type === 'deposit_v2') {
            this.events.push(item)
            this.deposit_v2 = item.id
          }
          if (item.is_show_in_deposit === 1) {
            if (item.type === 'daily_multiple_deposit' && this.memberInfo.third_deposit_amount !== 0) {
              this.getTransactions()
              this.events.push(item)
            } else if (item.type !== 'deposit_v2' && item.type !== 'daily_multiple_deposit') {
              this.events.push(item)
            }
          }
        }
      }
      this.$store.dispatch('initializeSortedEvents', this.events)
      for (const i in this.events) {
        getEventDetail(this.events[i].id).then(r => {
          const event = r.data.data
          if (event.type === 'daily_multiple_deposit') {
            this.multipleDeposit = event
            event.setting.forEach(item => {
              if (item.condition_value === this.getDayNumber()) this.todayArr.push(item)
            })
          }
          event.select = false
          this.events.splice(i, 1, event)
        })
      }
      if (this.sortedEvents) this.updateSwiperWrapperStyle()
    })
  },

  mounted() {
    this.startCountdown()
    this.preloadTypeDescriptions([1, 2, 3, 4])
  },

  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },

  methods: {
    // ── 渠道選擇 ────────────────────────────────────────────────
    onSelectPayment(payment) {
      this.selectPayment(payment, payment.name, payment.typeCode)
    },
    selectPayment(payment, name, code) {
      const kycMapping = {
        1: 'enable_KYC_deposit_channel',
        2: 'enable_KYC_deposit_ewallet',
        3: 'enable_KYC_deposit_cryptocurrency'
      }
      const kycKey = kycMapping[payment.typeNum]
      if (kycKey && this.permissionInfo[kycKey] && this.memberInfo.is_pass_KYC !== 1) {
        showNotice('アカウントの安全のため、入金前に KYC認証を完了してください。', () => {
          this.$router.push({ path: '/user/edit' })
        })
        return
      }

      this.percent = 0
      this.postForm.amount = code !== 'AmoPay' ? this.postForm.default : 30
      this.selectedCrypto = code === 'JetonCash' ? payment : null
      this.selectedTypeCode = code
      this.selectedPayment = payment
      this.postForm.payment_id = payment.payment_id
      this.selectedTypeName = name

      if (this.isBuyCrypto) {
        if (code === 'BankToBank' && !this.memberInfo.romanization) {
          showNotice(this.$t('Bao.credit_card_notice1'), () => {
            this.$router.push({ path: '/user/edit' })
          }, 'removeClose')
        }
        if (code === 'CreditCard' && !this.creditCard.credit_card_number.length &&
          payment.code !== 'HeroPay') {
          showNotice(this.$t('Bao.credit_card_notice'), () => {
            this.$router.push({ path: '/user/bank/create', query: { selectType: 4 }})
          })
        }
      } else {
        if (!this.isTheme('theme_purple')) this.isRedirectToBankCreatePage(code)
      }
    },
    isRedirectToBankCreatePage(code) {
      const needsCreditCard = (code === 'CreditCard' && this.selectedPayment.code !== 'HeroPay') ||
        this.selectedPayment.typeNum === 1
      if (needsCreditCard && !this.isHasCredit) {
        showNotice(this.$t('Bao.credit_card_notice'), () => {
          this.$router.push({ path: '/user/bank/create', query: { selectType: 1 }})
        }, 'removeClose')
      }
    },

    // ── 金額 ─────────────────────────────────────────────────
    handleAmount(amount) {
      this.postForm.amount = amount
      this.selectedAmount = amount
      const getPercentMap = (length) => {
        const list = this.selectedPayment.price_list
        if (length === 3) return { [list[1]]: 48, [list[2]]: 98 }
        if (length === 4) return { [list[1]]: 33, [list[2]]: 66.05, [list[3]]: 98.5 }
        if (length === 5) return { [list[1]]: 24.5, [list[2]]: 49, [list[3]]: 74, [list[4]]: 98.5 }
        return {}
      }
      this.percent = getPercentMap(this.selectedPayment.price_list.length)[amount] || 0
      this.cryptoAmount = ''
    },
    validateNumber(event) {
      if (this.selectedPayment.typeNum === 3 || this.selectedPayment.typeCode === 'JetonCash') {
        event.target.value = event.target.value.replace(/[^\d.]/g, '')
        this.cryptoAmount = event.target.value
        this.postForm.amount = this.cryptoAmount
      } else {
        event.target.value = event.target.value.replace(/[^0-9]/g, '')
        this.postForm.amount = event.target.value
        this.cryptoAmount = ''
      }
    },
    formatCryptoAmount() {
      const num = Number(this.cryptoAmount)
      const decimalPlaces = (num.toString().split('.')[1] || '').length
      return decimalPlaces > 8 ? num.toFixed(8) : num.toFixed(decimalPlaces)
    },

    // ── 匯率 ─────────────────────────────────────────────────
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.timeLeft > 0) { this.timeLeft-- } else { clearInterval(this.timer) }
      }, 1000)
    },
    handleRecheck(paymentId) {
      this.postForm.payment_id = paymentId
      this.fetchCurrentRate(paymentId)
    },
    resetTimer() {
      clearInterval(this.timer)
      this.timeLeft = 0
    },
    fetchCurrentRate(paymentId) {
      checkDepositRate(paymentId).then(response => {
        if (!response.data.data) {
          showNotice(this.$t('Bao.crypto_fail'))
          return
        }

        const matchCurrency = this.types.find(type => type.payment_id === paymentId)
        let newRate = response.data.data[matchCurrency.typeCode]
        if (matchCurrency.typeCode === 'JetonCash') {
          this.selectedCrypto = matchCurrency
          newRate = response.data.data['EUR']
        }

        matchCurrency.deposit_rate = newRate
        this.postForm.amount = this.cryptoAmount
      }).then(() => {
        this.timeLeft = 300
        this.startCountdown()
      })
    },

    // ── 表單驗證 ─────────────────────────────────────────────
    checkAccountErrors() {
      this.accountErrors = []
      if (!this.other.uid || !/^[a-zA-Z]\d{6}$/.test(this.other.uid)) {
        this.accountErrors.push(this.$t('Bao.deposit_account_error'))
      }
    },
    checkJetonErrors() {
      this.jetonErrors = []
      if (!this.other.uid || !/^\d+$/.test(this.other.uid)) {
        this.jetonErrors.push(this.$t('Bao.jeton_account_error'))
      }
    },
    checkJetonVoucherErrors(value) {
      this.jetonVoucherErrors = []
      const raw = value !== undefined ? value : this.Jcash.voucherNumber
      const input = raw.replace(/\D/g, '')
      this.Jcash.voucherNumber = input.slice(0, 19)
      if (this.Jcash.voucherNumber.length < 19) {
        this.jetonVoucherErrors.push(this.$t('Bao.jeton_voucher_error'))
      }
    },
    formatJcashExpirationDate(event) { this.formatExpirationDate(event, 'Jcash') },
    formatJcashSecurityCode(event) { this.formatSecurityCode(event, 'Jcash') },
    formatCardExpirationDateWhenSelect(month, year) {
      return `${month.padStart(2, '0')}/${year.slice(-2)}`
    },
    formatExpirationDate(event, field) {
      let input = event.target.value.replace(/\D/g, '')
      if (input.length > 2) input = input.slice(0, 2) + '/' + input.slice(2)
      this[field].expirationDate = input
      this.checkExpirationDateErrors(field)
    },
    checkExpirationDateErrors(field) {
      const errorField = `${field}ExpirationDateErrors`
      this[errorField] = []
      if (this[field].expirationDate.length < 5) return
      const [month, year] = this[field].expirationDate.split('/')
      this[field].expiryMonth = month
      this[field].expiryYear = `20${year}`
      if (!/^\d{2}\/\d{2}$/.test(this[field].expirationDate) || parseInt(month) < 1 || parseInt(month) > 12) {
        this[errorField].push(this.$t('Bao.expiration_date_error'))
      } else if (new Date(`20${year}`, parseInt(month) - 1) < new Date()) {
        this[errorField].push(this.$t('Bao.expiration_date_past_error'))
      }
    },
    formatSecurityCode(event, field) {
      const input = event.target.value.replace(/\D/g, '')
      this[field].securityCode = input.substr(0, 4)
      this.checkSecurityCodeErrors(field)
    },
    checkSecurityCodeErrors(field) {
      const errorField = `${field}SecurityCodeErrors`
      this[errorField] = []
      const minLen = field === 'Jcash' ? 4 : 3
      if (this[field].securityCode.length < minLen) {
        this[errorField].push(this.$t('Bao.security_code_error'))
      }
    },

    // ── 活動 ─────────────────────────────────────────────────
    isUnopenedEvent(item) {
      const { type } = item
      if (type === 'manual_first_deposit_v2' && this.memberInfo.first_deposit_amount !== 0) return true
      if (type === 'manual_first_deposit' && this.memberInfo.first_deposit_amount !== 0) return true
      if (type === 'manual_second_deposit' && this.memberInfo.second_deposit_amount !== 0) return true
      if (type === 'manual_third_deposit' && this.memberInfo.third_deposit_amount !== 0) return true
      if (type === 'daily_multiple_deposit' && this.multipleDeposit.length !== 0) {
        if (this.count >= this.activityCount) return true
      }
      return false
    },
    handleEvent(item) {
      if (this.isUnopenedEvent(item)) { item.select = false; this.selectedEvent = null; return }
      if (this.selectedEvent?.id === item.id) {
        item.select = !item.select
        if (item.select) this.checkQualification(item)
      } else {
        if (this.selectedEvent) this.selectedEvent.select = false
        item.select = true
        this.checkQualification(item)
      }
      setTimeout(() => {
        this.selectedEvent = item.select ? item : null
        this.$store.dispatch('selectEvent', item.id)
      }, 0.5)
      if (item.type === 'daily_multiple_deposit') {
        this.postForm.join_event_info = JSON.stringify([{ type: 'daily_multiple_deposit' }])
        this.showDepositText()
      } else {
        this.postForm.join_event_info = JSON.stringify([{ type: item.type }])
      }
      if (this.selectedEvent?.id === this.deposit_v2) {
        this.postForm.event_type = 'deposit_v2'
        this.postForm.event_join = true
      }
    },
    checkQualification(event) {
      getEventQualification(event.type)
        .then(r => {
          this.handleResponseCode(r.data.data.code)
          if (event.type === 'manual_first_deposit_v2') {
            showNotice(this.depositEventRule, null, true, false, '同意する')
          }
        })
        .catch(err => showNotice(err.response.data.msg))
    },
    handleResponseCode(code) {
      this.checkQual = false
      const codeMap = {
        1001: 'Bao.special_deposit_err6',
        2001: 'Bao.unavailible_4',
        3001: 'Bao.unavailible_4',
        2101: 'Bao.member_type_not_pass',
        5101: 'Bao.first_deposit_exist',
        5102: 'Bao.first_deposit_not_enough',
        5201: 'Bao.second_deposit_exist',
        5202: 'Bao.second_deposit_not_enough',
        5301: 'Bao.third_deposit_exist',
        5302: 'third_deposit_not_exist'
      }
      if (codeMap[code]) {
        this.lastResponseMessage = codeMap[code]
        showNotice(this.$t(this.lastResponseMessage))
      } else {
        this.checkQual = true
        this.lastResponseMessage = ''
      }
    },
    calculateBonus() {
      if (this.postForm.amount === '' || isNaN(this.postForm.amount)) return
      const isCryptoType = this.selectedCrypto !== null || this.selectedTypeCode === 'JetonCash'
      const amount = isCryptoType ? this.postForm.amount : parseInt(this.postForm.amount)
      if (!this.selectedEvent) { this.eventBonus = 0; return }

      if (this.selectedEvent.type === 'deposit_v2') {
        this.eventBonus = 0
        this.selectedEvent.setting.forEach(item => {
          if (amount <= item.max_deposit_amount && amount >= item.min_deposit_amount) {
            this.eventBonus = parseFloat(amount * (item.prize / 100))
          }
        })
      } else {
        const newAmount = isCryptoType ? amount * this.currencyRate.deposit_rate : amount
        if (newAmount < this.selectedEvent.setting[0].condition_value) { this.eventBonus = 0; return }
        const conditionValue = parseFloat(this.selectedEvent.setting[0].condition_value_2)
        const bonus = !isNaN(conditionValue) ? amount * (conditionValue / 100) : 0
        const cryptoBonus = isCryptoType ? bonus * this.currencyRate.deposit_rate : bonus
        this.eventBonus = cryptoBonus > this.selectedEvent.setting[0].condition_value_3
          ? this.selectedEvent.setting[0].condition_value_3
          : cryptoBonus
      }
    },
    calculateTotalBonus() {
      if (this.postForm.amount === '') return this.eventBonus
      if (this.selectedCrypto) return parseFloat(this.currencyRate.currencyRate) + this.eventBonus
      return parseInt(this.postForm.amount) + this.eventBonus
    },
    showDepositText() {
      this.todayArr.forEach(item => {
        if (item.condition_value_2 === this.count + 1) this.bounsLowerLimit = item.condition_value_3
      })
      return this.selectedEvent?.type === 'daily_multiple_deposit' &&
        this.selectedPayment && this.postForm.amount < this.bounsLowerLimit
    },
    getTransactions() {
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      const start = Math.floor(today.getTime() / 1000)
      const end = Math.floor(Date.now() / 1000)
      DepositTransactions({ start_at: start, end_at: end }).then(response => {
        response.data.data.list.forEach(item => {
          if (item.setting === null) {
            this.count++
          } else if (item.setting?.event) {
            item.setting.event.forEach(event => {
              if (!['manual_first_deposit', 'manual_second_deposit',
                'manual_third_deposit', 'custom_first_deposit'].includes(event.type)) {
                this.count++
              }
            })
          }
        })
      })
    },
    getDayNumber() {
      let day = new Date().getDay()
      if (day === 0) day = 7
      return day % 7
    },
    updateSwiperWrapperStyle() {
      this.$refs.eventSwiperPc?.updateSwiperWrapperStyle()
      this.$refs.eventSwiperMb?.updateSwiperWrapperStyle()
    },

    // ── 送出存款 ─────────────────────────────────────────────
    checkAmount(amount, min, max) {
      if (amount < min || amount > max) {
        showNotice(this.$t('Bao.deposit_check_amount', { min, max }))
        return false
      }
      return true
    },
    checkIsDeposit() {
      const matchCurrency = this.types.find(t => t.code === this.selectedPayment.code)
      if (!matchCurrency) return
      const limitMax = Math.floor(+matchCurrency.amount_limit_front?.max || 0)
      const limitMin = Math.floor(+matchCurrency.amount_limit_front?.min || 0)
      const isSpecial = ['CcPayment', 'AmoPay'].includes(matchCurrency.code)
      if (!isSpecial && !this.checkAmount(this.postForm.amount, limitMin, limitMax)) return

      if (this.first_deposit_at === 0 && this.before_withdrawal_module_setting !== null) {
        this.showModel = true
      } else {
        this.handleSubmit()
      }
    },
    handleSubmit() {
      this.showModel = false
      if (!this.checkQual) {
        if (this.lastResponseMessage) showNotice(this.$t(this.lastResponseMessage))
        return
      }

      this.$validator.validateAll().then((valid) => {
        if (valid && this.selectedPayment.id !== 'manual') {
          if (this.selectedEvent?.type !== 'daily_multiple_deposit') {
            joinEvent(this.selectedEvent.id).catch(err => showNotice(err.response.data.msg))
          }
        }
      })

      let encryptedPostForm = { ...this.postForm }
      if (this.selectedPayment.name === 'VegaWallet') {
        encryptedPostForm.other = {
          ...this.other,
          password: crypto.MD5(this.other.password).toString()
        }
      } else if (this.selectedPayment.name === 'JetonPay') {
        encryptedPostForm.other = { ...this.other }
      } else if (this.selectedPayment.typeCode === 'JetonCash') {
        encryptedPostForm = { ...encryptedPostForm, ...this.Jcash }
      } else if (this.selectedPayment.typeCode === 'CreditCard' && this.selectedPayment.code !== 'HeroPay') {
        encryptedPostForm = {
          ...encryptedPostForm, ...this.creditCard,
          cvv2: this.creditCard.securityCode,
          credit_card_number: this.selectedCreditCard.credit_card_number,
          member_creditcard_id: this.selectedCreditCard.id
        }
      } else if (this.selectedPayment.code === 'AmoPay') {
        encryptedPostForm.currency = 'USD'
      } else {
        delete encryptedPostForm.other
      }

      const encryptedOtherString = JSON.stringify(encryptedPostForm.other)
      const newWindow = window.open('about:blank', '_blank')
      const self = this

      DepositPayment({ ...encryptedPostForm, other: encryptedOtherString })
        .then((response) => {
          const result = response.data.data
          if (this.first_deposit_at === 0 && this.before_withdrawal_module_setting !== null &&
            this.isTheme('theme_gold') && process.env.VUE_APP_ENV === 'production') {
            sendFirstPurchaseEvent()
          }

          if (this.selectedPayment.name === 'VegaWallet' || this.selectedPayment.typeCode === 'JetonCash') {
            newWindow?.close()
            showNotice(
              this.$t('Bao.deposit_processing_notice_1') + '<br>' + this.$t('Bao.deposit_processing_notice_2'),
              () => { self.$router.push({ path: '/user/transaction-history' }) }
            )
            return
          }

          if (result.type === 'url') {
            if (newWindow && !newWindow.closed) newWindow.location.href = result.content
            showNotice(this.depositConfirmMessage, () => {
              self.$router.push({ path: '/user/transaction-history' })
            })
            let startCheck = false
            self.listenTimer = window.setInterval(() => {
              let newHost
              try { newHost = newWindow.location.host } catch (e) { newHost = 'cross domain' }
              if (newHost !== window.location.host) startCheck = true
              if ((newHost === window.location.host && startCheck) || newWindow.closed) {
                if (!newWindow.closed) newWindow.close()
                clearInterval(self.listenTimer)
                self.$router.push({ path: '/user/transaction-history' })
              }
            }, 1000)
          } else {
            newWindow?.close()
            showNotice(this.depositConfirmMessage, () => {
              self.$router.push({ path: '/user/transaction-history' })
            })
          }
        })
        .catch((error) => {
          newWindow?.close()
          setErrorMessage(error.response, this.errors)
        })
    },

    // ── 工具 ─────────────────────────────────────────────────
    isMobile() { return detectMob() },
    onApplyCoupon(code) {
      this.$refs.promoCode?.fillCoupon(code)
      this.$refs.promoCodeMb?.fillCoupon(code)
      this.showCoupon = false
    }
  }
}
</script>

<style>
.blue-link { color: #007aff; cursor: pointer; }
.swiper-button-prev.pro-arrow,
.swiper-button-next.pro-arrow {
  width: 20px; height: 20px;
  display: flex; align-items: center; justify-content: center;
  background-color: #978564; color: #fff;
  cursor: pointer; border-radius: 100%;
}
.swiper-pagination.swiper-pagination-fraction {
  bottom: 5px; width: 30%; left: 35%;
}
.swiper-button-prev, .swiper-button-next { top: 98%; }
.swiper-button-next { right: 40%; }
.swiper-button-prev { left: 40%; }
.swiper-button-prev:after, .swiper-button-next:after { font-size: 10px; }
@media (max-width: 992px) {
  .swiper-button-next { right: 33%; }
  .swiper-button-prev { left: 33%; }
}
</style>
